"use client";

import { usePathname, useSearchParams } from "next/navigation";
import React, { useEffect } from "react";
import { useMetrika } from "./useMetrika";
import { MetrikaInitializer } from "./MetrikaInitializer";

interface MetrikaContainerProps {
  enabled: boolean;
}

export function MetrikaContainer({ enabled }: MetrikaContainerProps) {
  const pathname = usePathname();
  const search = useSearchParams();
  const metrikaId = process.env.NEXT_PUBLIC_YANDEX_METRIKA_ID;
  const { hit } = useMetrika();

  useEffect(() => {
    hit(`${pathname}${search.size ? `?${search}` : ""}${window.location.hash}`);
  }, [hit, pathname, search]);

  if (!enabled || !metrikaId) return null;

  return (
    <MetrikaInitializer
      id={parseInt(metrikaId)}
      initParameters={{ webvisor: true, defer: true }}
    />
  );
}
